/**
 * Parse a calendar date string as local midnight.
 * Safari/WebKit treats `new Date('yyyy-MM-dd')` as UTC, which shifts the day
 * in local time and can make react-datepicker highlight two cells.
 */
export function parseLocalDateString(dateString) {
  if (!dateString) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateString).trim());
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    return new Date(year, month, day);
  }

  const normalized = String(dateString).includes('T')
    ? dateString
    : `${dateString}T00:00:00`;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
